module.exports = new __parcel__URL__("lpb.a0612b0e.avif").toString();